// extracted by mini-css-extract-plugin
module.exports = {" _key":"dojo2-todo-mvc-kitchensink/todoSearch","search":"todoSearch-m__search__52e415284M1","searchIcon":"todoSearch-m__searchIcon__52e4151WeQC"};